<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">{{ $t('letrex.card.title') }}</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <letrex-form ref="letrexForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="letrex"
        @save="save"
        @generate="generate"
        @clear="clear"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import LetrexForm from './LetrexForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_LETREX_MODEL_, MODEL } from './LetrexModel';

export default {
  name: 'letrex-page',
  components: {
    LetrexForm,
    SidebarActions,
  },
  data() {
    return {
      fallbackModel: cloneDeep(MODEL),
    };
  },
  computed: {
    storeLetrex() {
      return this.$store.state.letrex.letrex;
    },
    letrex() {
      return this.storeLetrex || this.fallbackModel;
    },
  },
  watch: {
    storeLetrex: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          Events.$emit(_LOAD_LETREX_MODEL_, newValue);
        }
      },
    },
  },
  methods: {
    save() {
      this.$refs.letrexForm.save();
    },
    generate() {
      this.$refs.letrexForm.generate();
    },
    clear() {
      this.$refs.letrexForm.clear();
    },
  },
};
</script>
